import React from 'react';
import ChangePasswordForm from './change_password_form';

const ParentChangePassword = () => {
  return <ChangePasswordForm onSuccessRoute="/my-account" />;
};

export default ParentChangePassword;
